import React, { FC } from 'react';
import { CloseButton, Loader, Modal } from '../..';
import { IOuter } from './HelpModal.types';
import styles from './HelpModal.scss';
import { useBoolean } from '../../../../utils/hooks/useBoolean';

export const HelpModal: FC<IOuter> = ({ article, onClose }) => {
  const { value: isLoaded, setTrue: setLoadedTrue } = useBoolean(false);

  if (!article) {
    return null;
  }

  return (
    <Modal zIndex={7500} isOpen onRequestClose={onClose} contentLabel="help-modal" shouldCloseOnOverlayClick>
      <div className={styles.content}>
        <CloseButton className={styles.closeButton} skin="lightFilled" size="medium" onClick={onClose} />

        <iframe src={article} className={styles.iframe} onLoad={setLoadedTrue} />

        {!isLoaded && (
          <div className={styles.loaderWrapper}>
            <Loader />
          </div>
        )}
      </div>
    </Modal>
  );
};
